import { ReactNode } from 'react';
import { useMediaQuery, useTheme } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';

import { useStyles } from './sign-up-banner.styles';
import { Button } from '../../../../common/button-new';
import { InternalLinks } from '../../../../../constants';
import { getDayPeriod } from './time-based-images';
import { useDayPeriodResponsiveImage } from '../../../../../hooks/use-day-period-responsive-image';
import { v2026PP05577 } from '../../../../../constants/veeva';
import { Veeva } from '../../../../common/veeva';

export const SignUpBanner = (): JSX.Element => {
  const intl = useIntl();
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isDesktop = useMediaQuery(theme.breakpoints.up('xl'));
  const dayPeriod = getDayPeriod();
  const selectedSrc = useDayPeriodResponsiveImage();

  return (
    <div
      className={`${classes.root} ${
        dayPeriod === 'morning' ? classes.rootMorning : dayPeriod === 'afternoon' ? classes.rootAfternoon : classes.rootEvening
      }`}
      data-testid="slide"
    >
      <div className={classes.inner}>
        <div className={classes.content} data-testid="slide-content">
          <h1 className={classes.title} data-testid="title">
            {intl.formatMessage({
              id:
                dayPeriod === 'morning'
                  ? 'signUpBanner.morning.title'
                  : dayPeriod === 'afternoon'
                    ? 'signUpBanner.afternoon.title'
                    : 'signupBanner.evening.title',
            })}
          </h1>
          <p className={classes.text}>
            {intl.formatMessage(
              {
                id:
                  dayPeriod === 'morning'
                    ? 'signUpBanner.title'
                    : dayPeriod === 'afternoon'
                      ? 'signUpBanner.afternoon.text'
                      : 'signupBanner.evening.text',
              },
              {
                span: (chunks: ReactNode) => <span className={classes.newLine}>{chunks}</span>,
                sup: (chunks: ReactNode) => <sup>{chunks}</sup>,
              },
            )}
          </p>
          {isMobile && (
            <div className={classes.image} aria-hidden="true" data-testid="slide-img">
              <img src={selectedSrc} alt="" />
            </div>
          )}
          <Button rootClasses={classes.button} data-testid="signup-button" to={InternalLinks.ecpLocator} style="light">
            <FormattedMessage id="signUpBanner.button" />
          </Button>
        </div>
        {!isMobile && (
          <div className={classes.image} aria-hidden="true" data-testid="slide-img">
            <img
              src={selectedSrc}
              width={isDesktop ? 374 : undefined}
              height={isDesktop ? 248 : undefined}
              alt=""
            />
          </div>
        )}
      </div>
      <div className={classes.veevaContainer}>
        <Veeva veevaNumber={v2026PP05577} isRight></Veeva>
      </div>
    </div>
  );
};
